import styled from 'styled-components'
import { CheckedIcon, CrossIcon } from 'icons'

type Props = {
  consents: {
    name: string
    agreed: boolean
  }[]
}

export default function Consents({ consents }: Props) {
  return (
    <Wrapper>
      {consents.map(({ name, agreed }) => (
        <span key={name}>
          {agreed ? <Checked /> : <UnChecked />}
          <span>{name}</span>
        </span>
      ))}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  row-gap: 8px;
  column-gap: 24px;
  max-width: 400px;

  svg {
    margin-right: 8px;
  }
`

const Checked = styled(CheckedIcon)`
  color: var(--green);
`

const UnChecked = styled(CrossIcon)`
  color: var(--orange);
`
